import { useNoteNames } from "../../Project/ProjectStore"
import { ClassNames } from "../../Util/ClassNames"
import { Music } from "../../Util/Music/Music"
import './LinearChainOfFifths.scss'

export function LinearChainOfFifths(props:{tonic:number, selectedPositions:number[], hilitedPositions:number[], visiblePositions:number[]}){
    const allPositions:number[] = [3,0,4,1,5,2,6]
    const noteNames:string[] = useNoteNames()
    const tonics:number[] = Music.getKeyScale(props.tonic)
    

    const getNoteCells = () => {
            const cells:JSX.Element[] = []
            allPositions.forEach((position:number)=>{
                const tonic:number = tonics[position]
                const noteName:string = noteNames[tonic]
                const classNames:ClassNames = new ClassNames(['linear-note-name'])
                const isVisible:boolean = (props.visiblePositions.includes(position))
                if(!isVisible) classNames.addClass('invisible')
                const isHilited:boolean = (props.hilitedPositions.includes(position))
                if(isHilited) classNames.addClass('hilited')
                const isSelected:boolean = (props.selectedPositions.includes(position))
                if(isSelected) classNames.addClass('selected')
                cells.push(<td key={position} className={classNames.toString()}>{noteName}</td>)
            })
            return cells
        }
        const getPositionCells = () => {
            const cells:JSX.Element[] = []
            allPositions.forEach((position:number)=>{
                const classNames:ClassNames = new ClassNames(['linear-note-number'])
                const isVisible:boolean = (props.visiblePositions.includes(position))
                if(!isVisible) classNames.addClass('invisible')
                const isHalo:boolean = (props.hilitedPositions.includes(position))
                if(isHalo) classNames.addClass('hilited')
                const isSelected:boolean = (props.selectedPositions.includes(position))
                if(isSelected) classNames.addClass('selected')
                cells.push(<td key={position} className={classNames.toString()}>{position + 1}</td>)
            })
            return cells
        }
    return(
                <div className={'linear-chain-of-fifths'}>
                    <table cellSpacing="0">
                        <tbody>
                            <tr className={'notes'}>
                                {getNoteCells()}
                            </tr>
                            <tr className={'numbers'}>
                                {getPositionCells()}
                            </tr>
                        </tbody>
                    </table>
                </div>
    )
}